import React from "react";
import { useParams } from "react-router-dom";
import SourcesTab from "./SourcesTab";

/**
 * Dedicated page for managing bot sources
 * Uses the existing SourcesTab component
 */
const ManageSourcesPage = ({ bot }) => {
  const { id: botId } = useParams();

  return (
    <div className="min-w-0">
      {/* Niente sfondo bianco né overflow nascosto: lo sfondo della sezione esce ai lati. */}
      <div className="min-w-0">
        <SourcesTab botId={botId} bot={bot} showHeader={true} />
      </div>
    </div>
  );
};

export default ManageSourcesPage;
